import { getHeaderWithAnchorsHeight } from '@/shared/lib/utils/getHeaderWithAnchorsHeight';

export const scrollToAnchor = (id: string) => {
    const section = document.getElementById(id);
    const offset = getHeaderWithAnchorsHeight();

    if (section) {
        const yOffset = -offset;
        const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }
};
